import React, { useState } from 'react';
import CalenderEventsCalendar from '../components/CalenderEventsCalendar';

function CalendarPage() {
    const now = new Date();
    const [date, setDate] = useState(() => new Date(now.getFullYear(), now.getMonth(), 1));

    const year = date.getFullYear();
    const month = date.getMonth() + 1;

    const monthNames = [
        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ];

    return (
        <div className="calendar-page video-archive-page">
            <div className="page-title">
                <div className="container headline">
                    <h1>Event Calendar</h1>
                    <p>Do you want to see your event listed here, too? Just fill out the form: <a href="https://forms.office.com/e/GW9HA4yQaD" target="_blank">add my Event</a></p>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-auto">
                            <label className="form-label me-2">Jahr</label>
                            <select
                                className="form-select form-select-sm d-inline-block"
                                style={{ width: 'auto' }}
                                value={year}
                                onChange={(e) =>
                                    setDate((d) => new Date(Number(e.target.value), d.getMonth(), 1))
                                }
                            >
                                {Array.from({ length: 7 }, (_, i) => year - 3 + i).map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-auto">
                            <label className="form-label me-2">Monat</label>
                            <select
                                className="form-select form-select-sm d-inline-block"
                                style={{ width: 'auto' }}
                                value={month}
                                onChange={(e) =>
                                    setDate((d) => new Date(d.getFullYear(), Number(e.target.value) - 1, 1))
                                }
                            >
                                {monthNames.map((m, i) => (
                                    <option key={m} value={i + 1}>{m}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <CalenderEventsCalendar
                        date={date}
                        onDateChange={setDate}
                        outputStyle="calendar"
                    />
                </div>
            </section>
        </div>
    );
}

export default CalendarPage;
